export default "__VITE_ASSET__5a3fb24d__"